const initialState = {
  selectedModule: "", // Initial state for selected company name
};

const SelModule = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SELECTED_MODULE":
      return {
        ...state,
        selectedModule: action.payload,
      };
    default:
      return state;
  }
};

export default SelModule;
